import { render, staticRenderFns } from "./AddTreatmentRequest.vue?vue&type=template&id=1d204f71&scoped=true&"
import script from "./AddTreatmentRequest.vue?vue&type=script&lang=ts&"
export * from "./AddTreatmentRequest.vue?vue&type=script&lang=ts&"
import style0 from "./AddTreatmentRequest.vue?vue&type=style&index=0&id=1d204f71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d204f71",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VBtn,VChip,VCombobox,VSelect,VTextField,VTextarea})
